
























































































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';

@Component
export default class Pagination extends Vue {
  @Prop() readonly amountPage!: number;

  @Prop() readonly currentPage!: number;

  @Prop() readonly changePage!: Function;

  visibleButton: Array<number> = [];

  numPage = 0;

  isshowBtn = true;

  beforeUpdate() {
    this.rendenPage();
  }

  created() {
    this.rendenPage();
  }

  @Watch('currentPage', { immediate: true, deep: true })
  checkPage() {
    this.numPage = this.currentPage;
  }

  @Watch('numPage', { immediate: true, deep: true })
  checkBtn() {
    if (this.amountPage >= this.numPage && this.numPage > 0) {
      this.isshowBtn = false;
    } else {
      this.isshowBtn = true;
    }
  }

  rendenPage() {
    this.visibleButton = [];
    const pageList = Array.from(Array(this.amountPage), (_, i) => i + 1);
    const idx = pageList.findIndex((i) => i === this.currentPage);
    if (this.$mq === 'mdNav') {
      const left = pageList.slice(idx - 3 < 0 ? 0 : idx - 2, idx);
      const right = pageList.slice(idx, idx + 3 > pageList.length ? pageList.length : idx + 3);
      this.visibleButton = [...left, ...right];
    } else {
      const left = pageList.slice(idx - 1 < 0 ? 0 : idx - 0, idx);
      const right = pageList.slice(idx, idx + 1 > pageList.length ? pageList.length : idx + 1);
      this.visibleButton = [...left, ...right];
    }
  }

  colorBtn(i) {
    return i === this.currentPage ? '' : 'white';
  }
}
